import { DATE_PRESETS, DATE_SHORTCUTS } from './filter.constants';

const TAIL = /\s+(negli ultimi|nelle ultime|da meno di|entro gli ultimi)$/i;

export const dateSectionTitle = (label: string): string => label.replace(TAIL, '');

const short = (iso: string): string => {
    const [year, month, day] = iso.split('-');
    return day && month && year ? `${day}/${month}/${year.slice(2)}` : iso;
};

export function dateWindowLabel(value: string): string {
    if (value.startsWith('range:')) {
        const [, from = '', to = ''] = value.split(':');
        if (from && to) return `${short(from)} – ${short(to)}`;
        if (from) return `dal ${short(from)}`;
        if (to) return `fino al ${short(to)}`;
        return 'qualsiasi data';
    }
    const shortcut = DATE_SHORTCUTS.find((entry) => entry.value === value);
    if (shortcut) return shortcut.label.toLowerCase();
    const preset = DATE_PRESETS.find((entry) => entry.value === value);
    return preset ? `ultimi ${preset.label}` : value;
}
